export const INVESTOR_PHONE_FORM = {
	TELEPHONE_PREFIX: 'telephonePrefix',
	PHONE_NUMBER: 'phoneNumber',
};
